module.exports = __webpack_public_path__ + "img/LLPRO_CEFR_banner_bg.1cedefc2.png";